const Timeline = ({ children }) => {
    return (
        <div class="main-content__timeline">
            {children}
        </div>
    );
};

export default Timeline;
